var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPhoneBk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5962",
    style: {
      fill: "#fff"
    },
    d: "M0 0h24v24H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-phone",
    d: "M7.158 10.8a13.216 13.216 0 0 0 5.749 5.749l1.919-1.919a.867.867 0 0 1 .89-.209 9.951 9.951 0 0 0 3.114.5.875.875 0 0 1 .872.872v3.045a.875.875 0 0 1-.872.872A14.829 14.829 0 0 1 4 4.872.875.875 0 0 1 4.872 4h3.054a.875.875 0 0 1 .872.872 9.911 9.911 0 0 0 .5 3.114.875.875 0 0 1-.218.89L7.158 10.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneBk);
export default __webpack_public_path__ + "static/media/ic-phone-bk.f88749e51c42ff10ce1ae23388eed365.svg";
export { ForwardRef as ReactComponent };